import React from "react";
import styled from "styled-components";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Helmet } from "react-helmet";

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: absolute;
  z-index: 10000000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;

  h1 {
    font-size: 4rem;
    text-transform: uppercase;
  }

  svg {
    color: #d32f2f;
    font-size: 8rem;
  }

  img {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
    }

    h2 {
      font-size: 1rem;
      text-align: center;
    }

    svg {
      font-size: 5rem;
    }
  }
`;

const BlockPage = () => {
  return (
    <>
      <Helmet>
        <style>
          {`
            @media screen and (max-width: 768px) {
              #retailcrm-consultant-app .consultant-widget-wrap {
                display: block;
                bottom: 0px !important;
              }
            }
          `}
        </style>
      </Helmet>
      <Container>
        <h1>¡Lo Sentimos!</h1>
        <h2
          style={{ color: "#fff", margin: "1rem", textTransform: "uppercase" }}
        >
          El acceso a nuestro sitio web está restringido en su ubicación.{" "}
        </h2>
        <ErrorOutlineIcon />
      </Container>
    </>
  );
};

export default BlockPage;
